import React, { FC, HTMLAttributes } from 'react';
import * as classes from './Container.module.scss';
import cn from 'classnames';

const Container: FC<HTMLAttributes<HTMLElement>> = ({ children, ...rest }) => {
  return (
    <div {...rest} className={cn(rest.className, classes.containerFluid)}>
      {children}
    </div>
  );
};

export default Container;
